import React from 'react'
import {useIntl} from 'react-intl'

import {Text} from '@vio/atlas/Text'

import {CashbackMessageProps, CashbackProps} from '../../../types/cashback'

const Wards = ({value}: Pick<CashbackProps, 'value'>) => {
  return (
    <>
      <Text
        tag="span"
        variant="bodyXS"
        colorPath="content.brand.primary"
        style={{textDecoration: 'line-through'}}
      >
        W
      </Text>
      <Text tag="span" variant="bodyXS" colorPath="content.brand.primary">
        {value}
      </Text>
    </>
  )
}

export const CashbackWeWard = ({
  value,
  type,
  variant,
  messages
}: CashbackMessageProps) => {
  const {formatMessage} = useIntl()
  if (type !== 'points') return null

  return (
    <Text
      variant="bodyXS"
      tag="span"
      colorPath="content.neutral.secondary"
      style={{whiteSpace: 'nowrap'}}
    >
      {variant === 'short' ? (
        <Wards value={value} />
      ) : (
        formatMessage(messages.cashbackLongMessage!, {
          value: <Wards value={value} />
        })
      )}
    </Text>
  )
}
